import { LaborCalendarBoard } from '../calendario/LaborCalendarBoard';
import { LABOR_CALENDAR_VIEWS } from '../calendario/services/laborScheduleService';

const Asignaciones = () => (
  <LaborCalendarBoard
    allowedViews={[LABOR_CALENDAR_VIEWS.EMPLOYEE, LABOR_CALENDAR_VIEWS.TEAM]}
    title="Asignaciones"
    description="Consulta y gestiona el calendario de empleados y equipos."
  />
);

export default Asignaciones;
